import React from 'react';
import Icon from '@ant-design/icons';

// @ant-design/icons 6.1.0 ships no factory or industry glyph, so this is a
// hand-drawn one on the same 1024 viewBox the library uses.
//
// Drawn with strokes rather than a filled outline: a saw-tooth shed roof needs a
// cut-out to render as a fill, and that geometry is easy to get subtly wrong.
// Strokes make every coordinate independently checkable.
//
// Routed through the library's Icon wrapper so it inherits the .anticon sizing,
// colour and alignment that every other sidebar icon gets.
function FactorySvg() {
  return (
    <svg
      viewBox="0 0 1024 1024" width="1em" height="1em"
      fill="none" stroke="currentColor" strokeWidth="72"
      strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false"
    >
      {/* saw-tooth shed: left wall up, three teeth, right wall down */}
      <path d="M160 832V512l160-112v112l160-112v112l160-112v432" />
      {/* chimney, standing on the floor to the right of the shed */}
      <path d="M736 832V320h128v512" />
      {/* floor */}
      <path d="M96 832h832" />
      {/* two machine bays, filled so they read at 14px */}
      <path d="M296 640h72v72h-72z" fill="currentColor" strokeWidth="0" />
      <path d="M456 640h72v72h-72z" fill="currentColor" strokeWidth="0" />
    </svg>
  );
}

const FactoryOutlined = (props) => <Icon component={FactorySvg} {...props} />;

export default FactoryOutlined;
